module.exports = __webpack_public_path__ + "static/media/Major Project ETRX 2023-24.db2371c9.pdf";